module.exports = __webpack_public_path__ + "static/about-insta-9@2x-6a73811e063ef12ace9a74a9741e75a9.jpg";